<script>
export default {
  name: 'basic-related-tip',
};
</script>

<template>
  <div class="opc-zsched__basic-related-tip">
    {{ $t('billing.scheduler.basic_include_tip') }}
  </div>
</template>

<style scoped lang="scss">
.opc-zsched__basic-related-tip {
  font-size: 14px;
  font-weight: 450;
  line-height: 16.8px;
  color: #666487;
  margin-top: 12px;
}
</style>
